import React from "react";
import "./Hero.css";
import heroImage from "../../img/New/heroDestop.png";
import heroImage2 from "../../img/New/heroMoblie2.png";

const Hero = () => {
  return (
    <section className="uniq-oglitz-hero">
      <div className="uniq-oglitz-hero__container">
        {/* LEFT CONTENT */}
        <div className="uniq-oglitz-hero__content">
          <span className="uniq-oglitz-hero__badge">
            Oglitz Software • Digital Product Studio
          </span>

          <h1 className="uniq-oglitz-hero__title">
            Crafting Premium Digital
            <br />
            <span className="uniq-oglitz-hero__title--brand">
              Experiences That Scale
            </span>
          </h1>

          <p className="uniq-oglitz-hero__subtitle">
            We design and develop high-performance software, web & mobile
            applications with clean architecture, premium UI, and long-term
            scalability.
          </p>

          <div className="uniq-oglitz-hero__actions">
            <a
              href="/start-project"
              className="uniq-oglitz-hero__btn uniq-oglitz-hero__btn--primary"
            >
              Start a Project →
            </a>

            <a
              href="/project"
              className="uniq-oglitz-hero__btn uniq-oglitz-hero__btn--secondary"
            >
              View Our Work
            </a>
          </div>

          {/* TRUST */}
          <div className="uniq-oglitz-hero__trust">
            <span>Trusted by teams in</span>
            <div className="uniq-oglitz-hero__logos">
              <span>SaaS</span>
              <span>FinTech</span>
              <span>E-Commerce</span>
              <span>Enterprise</span>
            </div>
          </div>
        </div>

        {/* RIGHT PREMIUM VISUAL */}
        <div className="uniq-oglitz-hero__visual">
          {/* Glow base */}
          <div className="uniq-oglitz-hero__glow" />

          {/* Desktop mockup (PRIMARY) */}
          <div className="uniq-oglitz-hero__mockup uniq-oglitz-hero__mockup--desktop">
            <img
              loading="eager"
              decoding="async"
              src={heroImage}
              alt="Dashboard UI"
            />
          </div>

          {/* Desktop pill */}
          <span className="uniq-oglitz-hero__pill uniq-oglitz-hero__pill--top">
            Enterprise Architecture
          </span>

          {/* Mobile mockup (SECONDARY) */}
          <div className="uniq-oglitz-hero__mockup uniq-oglitz-hero__mockup--mobile">
            <img
              loading="eager"
              decoding="async"
              src={heroImage2}
              alt="Mobile App UI"
            />
          </div>

          {/* Mobile pills */}
          <span className="uniq-oglitz-hero__pill uniq-oglitz-hero__pill--mid">
            Design-First Experience
          </span>

          <span className="uniq-oglitz-hero__pill uniq-oglitz-hero__pill--bottom">
            Built for Scale
          </span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
